// extracted by mini-css-extract-plugin
export default {"card":"kma-z","isSwatchGrouping":"lma-z"};